export default {
  name: "Referral and Hiring Instructions",
  prefix: "F",
  sections: [
    {
      divider: "hide",
      name: "",
      fields: [
        {
          code: "F.1",
          machine_name: "eta_790a_g1_how_to_apply",
          widget: "text_area",
          label: `Explain <u>how</u> prospective applicants may be considered for employment under this job order, including verifiable contact information for the employer, methods of contacting the employer
          directly, and the days and hours applicants will be considered for the job opportunity. 
          <br>
          <br>
          <em>(A complete response must be included in the space below on this form. Use of <strong>Addendum C</strong> is not permitted.)</em>`,
          validate: [
            "required",
            {
              minLength: 5,
              message: "Referral/Hiring must contain at least 5 characters.",
            },
          ],
          tooltip: `Explain how prospective applicants may be considered for employment under this job order, including verifiable contact information for the employer and the methods of contacting the employer directly (e.g., email, phone) that may be used to refer prospective U.S. applicants for the job opportunity.  Summarize how applicants are to be considered, referred, and hired.  For example, indicate the days and hours that the employer or the employer’s authorized hiring representative will be available to interview workers by telephone and/or in-person and whether anybody different from the employer has hiring authority.  
          <br>
          <br>
          <em>Important Note</em>:  A complete response must be provided using the space provided on the Form ETA-790A.  Use of Addendum C is <strong>NOT PERMITTED</strong>.
          `,
          width: 8,
          rows: 10,
          inputLimit: 4000,
          is_required: true,
        },
      ],
    },
    {
      name: "Two of three entries required*",
      fields: [
        {
          code: "F.2",
          machine_name: "eta_790a_g2_apply_phone",
          widget: "phone",
          label: "Employer Telephone Number to Apply",
          validate: [
            "phone",
            {
              subsetOfSetRequired: "eta_790a_g2_apply_phone",
              message:
                "Enter at least two (2) verifiable methods by which prospective U.S. workers can contact the employer and apply for the job opportunity.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  // "eta_790a_g4_apply_url",
                  "eta_790a_g2_apply_phone",
                  // "eta_790a_g3_apply_email"
                  "apply_url",
                  "apply_email",
                ],
              },
            },
          ],
          tooltip: `Enter the employer’s area code and business telephone number prospective U.S. applicants may use to call the employer to be considered for the job opportunity.  If a phone number is not available, leave this field <strong>BLANK</strong> and the system will insert "N/A" at submission of the application.  <strong>DO NOT</strong> include the telephone number of the local or state offices of the SWA.`,
        },
        {
          code: "F.3",
          machine_name: "apply_extensions",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip: `Enter the extension of the employer’s telephone number for prospective U.S. applicants to use to call the employer to be considered
          for the job opportunity, if applicable.`,
        },
        {
          code: "F.4",
          // machine_name: "eta_790a_g3_apply_email",
          machine_name: "apply_email",
          widget: "text",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              // subsetOfSetRequired: "eta_790a_g3_apply_email",
              subsetOfSetRequired: "apply_email",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  // "eta_790a_g4_apply_url",
                  "eta_790a_g2_apply_phone",
                  // "eta_790a_g3_apply_email"
                  "apply_url",
                  "apply_email",
                ],
                allowNAs: false,
              },
            },
          ],
          label: "Employer Email Address to Apply",
          maxLength: 60,
          tooltip: `4.	Enter the employer’s business email address prospective U.S. applicants may use to email the employer to be considered for the job opportunity in the format name@emailaddress.top-leveldomain.  If email is not a method of contact prospective U.S. applicants may use to be considered for the job opportunity, enter “<strong>N/A</strong>.” <strong>DO NOT</strong> include the email address of the local or state offices of the SWA.”`,
        },
        {
          code: "F.5",
          // machine_name: "eta_790a_g4_apply_url",
          machine_name: "apply_url",
          widget: "text",
          label: "Employer Website Address (URL) to Apply",
          validate: [
            {
              url: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              subsetOfSetRequired: "eta_790a_g4_apply_url",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  // "eta_790a_g4_apply_url",
                  "eta_790a_g2_apply_phone",
                  // "eta_790a_g3_apply_email"
                  "apply_url",
                  "apply_email",
                ],
                allowNAs: false,
              },
            },
          ],
          maxLength: 70,
          tooltip: `Enter the employer’s business website address (URL) in the format <a href="www.employerwebsitename.top-leveldomain" target="_blank">www.employerwebsitename.top-leveldomain</a>. If the
          employer does not have a business website address or its website is not a method of contact prospective U.S. applicants
          may use to be considered for the job opportunity, enter “N/A.” Examples of valid suffixes include:
          <br>
          <br>
          .com - commercial business <br>
          .org - Organizations (nonprofit) <br>
          .edu - Educational institutions <br>
          .net - Network organizations <br>
          .gov - Government agencies <br>
          .mil – Military
          <br>
          <br>
          <em>Important Note</em>:  <u><strong>DO NOT</strong> include the website link for Seasonaljobs.dol.gov or the website location of the labor exchange system maintained by, or on behalf of, the SWA that is used for intrastate or interstate clearance.  Otherwise, the SWA and/or CO will issue a NOD requesting removal of these government websites and request disclosure of a business website maintained by, or on behalf of, the employer where prospective applicants may apply for the job opportunity.</u>
          `,
        },
      ],
    },
  ],
};
